import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TaskCreationConfigOkrsQueryVariables = Types.Exact<{
  okrId: Types.Scalars['String']['input'];
}>;


export type TaskCreationConfigOkrsQuery = { okr?: { id: string, taskCreationConfigs?: Array<{ id: string, actionItemsLinkedCount: number, searchText?: string | null, externalLink?: string | null, createdByUser?: { name?: string | null, id: string } | null, syncConfig?: { syncStatus: Types.SyncStatusEnum } | null }> | null } | { id: string, taskCreationConfigs?: Array<{ id: string, actionItemsLinkedCount: number, searchText?: string | null, externalLink?: string | null, createdByUser?: { name?: string | null, id: string } | null, syncConfig?: { syncStatus: Types.SyncStatusEnum } | null }> | null } | null };


export const TaskCreationConfigOkrsDocument = /*#__PURE__*/ gql`
    query taskCreationConfigOkrs($okrId: String!) {
  okr(filters: {okrId: $okrId}) {
    ... on ObjectiveType {
      id
      taskCreationConfigs {
        id
        createdByUser {
          name
          id
        }
        actionItemsLinkedCount
        searchText
        externalLink
        syncConfig {
          syncStatus
        }
      }
    }
    ... on KeyResultType {
      id
      taskCreationConfigs {
        id
        createdByUser {
          name
          id
        }
        actionItemsLinkedCount
        searchText
        externalLink
        syncConfig {
          syncStatus
        }
      }
    }
  }
}
    `;

export function useTaskCreationConfigOkrsQuery(options: Omit<Urql.UseQueryArgs<TaskCreationConfigOkrsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskCreationConfigOkrsQuery, TaskCreationConfigOkrsQueryVariables>({ query: TaskCreationConfigOkrsDocument, ...options });
};